import React from 'react'
import { Popup } from 'antd-mobile-v5'

import styles from '../AllCards.module.css'

const CardPopupWrapper = ({ children, setVisible, visible, imageUrl, name, authorName }) => {
  return (
    <Popup
      visible={visible}
      onMaskClick={() => {
        setVisible(false)
      }}
      bodyStyle={{
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
      }}
    >
      <div className={styles.popup}>
        <img src={imageUrl} className={styles.img} />
        <div className={styles.title}>
          <div className={styles['story-name']}>《{name}》</div>
          <div className={styles['author-name']}>{authorName}</div>
        </div>
        {children}
      </div>
    </Popup>
  )
}

export default CardPopupWrapper
